module.exports = __webpack_public_path__ + "img/cake.1176a165.png";